// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qNZfH9mBD4kMQG8zmkli {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 16px 0;
    height: 100%;
}

.RM9bCvAkhCH9U_x5nDNK {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 16px 0;
    height: 100%;
}

.iPgiEAobKbDNiSWaKT5N {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;
    height: 100%;
}

.LuYMHEGwzB5geUoM8ccb {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 4px;
}

.nYYM8VTiGScR_Ac8sokE {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 16px;
    height: 100%;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/Layout/Footer/DesktopFooter/DesktopFooter.module.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;IACR,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,SAAS;IACT,YAAY;AAChB","sourcesContent":[".container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 0;\n    height: 100%;\n}\n\n.containerCentered {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    padding: 16px 0;\n    height: 100%;\n}\n\n.leftSection {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 8px;\n    height: 100%;\n}\n\n.logoContainer {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 4px;\n}\n\n.rightSection {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 16px;\n    height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `qNZfH9mBD4kMQG8zmkli`,
	"containerCentered": `RM9bCvAkhCH9U_x5nDNK`,
	"leftSection": `iPgiEAobKbDNiSWaKT5N`,
	"logoContainer": `LuYMHEGwzB5geUoM8ccb`,
	"rightSection": `nYYM8VTiGScR_Ac8sokE`
};
export default ___CSS_LOADER_EXPORT___;
